import { AppPageLayout } from "@/components/common/AppPageLayout";
import { publicFormRoutePaddingClass } from "@/features/pages/components/formPageLayout";
import { useSelectFormById } from "@/features/forms/api/selectFormById";
import { useAppLocale } from "@/features/i18n/LocaleProvider";
import FormPage from "@/features/pages/components/FormPage";
import { useMsAdlFormPageContext } from "@/features/pages/hooks/useMsAdlFormPageContext";
import useFormPage from "@/features/pages/hooks/useFormPage";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

const Page = () => {
    const { pageIndex, formId } = Route.useParams();
    const navigate = useNavigate();
    const { locale } = useAppLocale();
    const { data: form } = useSelectFormById(formId, locale);
    const numericPageIndex = Number(pageIndex);

    const {
        currentPage,
        pageCount,
        msAdlSelectionInputId,
        renderPageIndex,
        isLastPageOverride,
        progressPageIndex,
        progressPageTotal,
    } = useMsAdlFormPageContext(form, numericPageIndex);

    const {
        form: reactHookForm,
        onSubmit,
        prevPage,
        nextPage,
        isLastPage,
        visitedPageCount,
    } = useFormPage({
        pageCount,
        inputs: currentPage?.inputs ?? [],
        nextEntry: null,
        form,
        isLastPageOverride,
        nextPageFn: (newPageIndex) => {
            navigate({
                to: "/forms/$formId/page/$pageIndex",
                params: { formId, pageIndex: String(newPageIndex) },
                resetScroll: false,
            });
        },
        prevPageFn: (newPageIndex) => {
            navigate({
                to: "/forms/$formId/page/$pageIndex",
                params: { formId, pageIndex: String(newPageIndex) },
                resetScroll: false,
            });
        },
        successFn: () => {
            navigate({
                to: "/forms/$formId/page/$pageIndex",
                params: { formId, pageIndex: String(numericPageIndex + 1) },
            });
        },
        completeFn: () => {
            navigate({ to: "/forms/$formId", params: { formId } });
        },
    });

    if (!form || !currentPage) return null;

    return (
        <AppPageLayout width="md" padding="sm" className={publicFormRoutePaddingClass}>
            <FormPage
                pageIndex={numericPageIndex}
                form={form}
                route={Route}
                formType="tracker"
                reactHookForm={reactHookForm}
                onSubmit={onSubmit}
                prevPage={prevPage}
                nextPage={nextPage}
                isLastPage={isLastPageOverride ?? isLastPage}
                visitedPageCount={visitedPageCount}
                msAdlSelectionInputId={msAdlSelectionInputId}
                renderPageIndex={renderPageIndex}
                progressPageIndex={progressPageIndex}
                progressPageTotal={progressPageTotal}
            />
        </AppPageLayout>
    );
};

export const Route = createFileRoute("/forms/$formId/page/$pageIndex/")({
    component: Page,
});
